function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 11.8056C27.6096 11.8056 30.1606 12.5794 32.3304 14.0292C34.5003 15.479 36.1914 17.5397 37.1901 19.9507C38.1887 22.3617 38.45 25.0146 37.9409 27.5741C37.4318 30.1336 36.1752 32.4846 34.3299 34.3299C32.4846 36.1752 30.1336 37.4318 27.5741 37.9409C25.0146 38.45 22.3617 38.1887 19.9507 37.1901C17.5397 36.1914 15.4791 34.5003 14.0292 32.3304C12.5794 30.1606 11.8056 27.6096 11.8056 25C11.8092 21.5017 13.2005 18.1478 15.6742 15.6742C18.1478 13.2005 21.5017 11.8092 25 11.8056V11.8056ZM25 10C22.0333 10 19.1332 10.8797 16.6665 12.528C14.1997 14.1762 12.2771 16.5189 11.1418 19.2597C10.0065 22.0006 9.70945 25.0166 10.2882 27.9264C10.867 30.8361 12.2956 33.5088 14.3934 35.6066C16.4912 37.7044 19.1639 39.133 22.0736 39.7118C24.9834 40.2906 27.9994 39.9935 30.7403 38.8582C33.4811 37.7229 35.8238 35.8003 37.472 33.3335C39.1203 30.8668 40 27.9667 40 25C40 21.0218 38.4196 17.2064 35.6066 14.3934C32.7936 11.5804 28.9783 10 25 10V10Z",
  fill: "#F3B541"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5501 37.2833C26.0862 17.8139 20.6223 12.0056 20.6223 12.0056",
  stroke: "#F3B541",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5389 23.0445C10.5389 23.0445 28.7778 24.6917 34.8389 15.4528",
  stroke: "#F3B541",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4805 35.1389C15.4805 35.1389 22.2055 21.625 39.3527 25.7861",
  stroke: "#F3B541",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 23.5,
  stroke: "#F3B541",
  strokeWidth: 3
});

var SvgIconDribbble = function SvgIconDribbble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDribbble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-dribbble.943ac227.svg";
export { ForwardRef as ReactComponent };